export { getCurrencySymbol } from "./getCurrentSymbol";